import React, {useState,useEffect} from "react";
import "./navbar.css";

import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    useMediaQuery,
    Button,
    useScrollTrigger,
    Slide,
    Menu,
    MenuItem,
    ListItemIcon,
} from "@material-ui/core";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { BrowserRouter, Route, Switch, Link } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";

// IMPORTING ICONS
import MenuIcon from "@material-ui/icons/Menu";
import SchoolIcon from "@material-ui/icons/School";
import PersonIcon from "@material-ui/icons/Person";
import BookmarksIcon from "@material-ui/icons/Bookmarks";

import NavLogo from "../../images/nav-logo.svg";
import Web3 from 'web3';

// LOCAL-STYLING
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    navheader: {
        fontSize: "21px",
    },
}));

function HideOnScroll(props) {
    const { children } = props;
    const trigger = useScrollTrigger();

    return (
        <Slide appear={false} direction={"down"} in={!trigger}>
            {children}
        </Slide>
    );
}

const Navbar = (props) => {
    const web3 = new Web3(Web3.givenProvider);
    const classes = useStyles();
    const [anchor, setAnchor] = React.useState(null);
    // const [isLogin,setIsLogin] = React.useState(false);

    const [metamaskAddress,setMetamaskAddress] = useState("");
    
    const [showAddress,setShowAddress] = useState(true);
    const [hideAddress,setHideAddress] = useState(false);

    const [menu,setMenu] = useState(false);
    const open = Boolean(anchor);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const handleMenu = () => {
        setMenu(!menu);
    };
    const closeMenu = () => {
        setMenu(false);
    }

    useEffect(() => {
        
    },[props.metamaskAddress])

    const disconnectWallet = () => {
        localStorage.clear();
        window.location.reload();
    }

    useEffect(async () => {
        const chainId = await web3.eth.getChainId();
        console.log("AAAA",chainId);

        
    },[]);

    return (
        <div className={classes.root}>
            <HideOnScroll {...props}>
                <AppBar>
                    <Toolbar>
                        <Typography
                            variant="h5"
                            component="p"
                            className={classes.title}
                        >
                            <img
                                className="shangu-logo"
                                src={NavLogo}
                                alt="shangu logo"
                            />
                            {/* <p className="navtitle">Legends of Shangu P2E Game</p> */}
                        </Typography>
                        {isMobile ? (
                            <>
                                

                                { !props.metamaskAddress.length>0 &&   
                                    <Button
                                    className="btn-public-sale btn-connect"
                                    onClick={props.connectWallet}
                                >
                                    Connect Wallet
                                </Button>}
                                
                                {
                                    props.metamaskAddress.length>0 && 
                                    <Button 
                                    className="btn-public-sale meta-address"
                                    onClick={disconnectWallet}
                                    onMouseEnter={() => setShowAddress(false)}
                                    onMouseLeave={() => setShowAddress(true)}
                                    >
                                        {showAddress && props.metamaskAddress.slice(0,12) + "..."}

                                        {!showAddress && "Disconnect"}
                                    </Button>
                                }
                                <IconButton
                                    className={classes.menuButton}
                                    edge="start"
                                    aria-label="menu"
                                    onClick={handleMenu}
                                >
                                    <MenuIcon />
                                </IconButton>
                                <div className={menu ? "show" : "hide-it"}>
                                <div
                                    id="menu-appbar"
                                    anchorEl={anchor}
                                    anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                    }}
                                    // KeepMounted
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                    }}
                                    open={open}
                                >
                                    <Typography variant="h6" onClick={closeMenu}>
                                        <a
                                            // variant="text"
                                            // component={Link}
                                            href="#buyShangu"
                                        >
                                            Mint
                                        </a>
                                    </Typography>

                                    <Typography variant="h6" onClick={closeMenu}>
                                        <a
                                            // variant="text"
                                            // component={Link}
                                            href="#artwork"
                                        >
                                            Artwork
                                        </a>
                                    </Typography>

                                    <Typography variant="h6" onClick={closeMenu}>
                                        <a
                                            // variant="text"
                                            // component={Link}
                                            href="#roadmap"
                                        >
                                            Roadmap
                                        </a>
                                    </Typography>

                                    <Typography variant="h6" onClick={closeMenu}>
                                        <a
                                            // variant="text"
                                            // component={Link}
                                            href="#ourTeam"
                                        >
                                            Team
                                        </a>
                                    </Typography>

                                    <Typography variant="h6" onClick={closeMenu}>
                                        <a
                                            // variant="text"
                                            // component={Link}
                                            href="#faqs-section"
                                        >
                                            FAQ
                                        </a>
                                    </Typography>
                                </div>
                                </div>
                            </>
                        ) : (
                            <div
                                className="nav-menu-large"
                                style={{ marginRight: "2rem" }}
                            >
                                <a
                                    // variant="text"
                                    // component={Link}
                                    href="#buyShangu"
                                >
                                    Mint
                                </a>
                                <a
                                    // variant="text"
                                    // component={Link}
                                    href="#artwork"
                                >
                                    Artwork
                                </a>
                                <a
                                    // variant="text"
                                    // component={Link}
                                    href="#roadmap"
                                >
                                    Roadmap
                                </a>
                                <a
                                    // variant="text"
                                    // component={Link}
                                    href="#ourTeam"
                                >
                                    Team
                                </a>
                                <a
                                    // variant="text"
                                    // component={Link}
                                    href="#faqs-section"
                                >
                                    FAQ
                                </a>
                                
                                
                                { !props.metamaskAddress.length>0 &&   
                                <Button
                                    className="btn-public-sale"
                                    onClick={props.connectWallet}
                                    >
                                        Connect Wallet
                                </Button>}
                                
                                {
                                    props.metamaskAddress.length>0 && 
                                    <Button 
                                    className="btn-public-sale meta-address"
                                    onClick={disconnectWallet}
                                    onMouseEnter={() => setShowAddress(false)}
                                    onMouseLeave={() => setShowAddress(true)}
                                    >
                                        {showAddress && props.metamaskAddress.slice(0,12) + "..."}

                                        {!showAddress && "Disconnect"}
                                    </Button>
                                }

                            </div>
                        )}
                    </Toolbar>
                </AppBar>
            </HideOnScroll>
        </div>
    );
};

export default Navbar;
